export const getReportService = state => state.reportService;
